import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    startLoader: (state, action) => {
      const { loader } = action.payload;
      state.loader = loader;
    }
  },
});

export const { startLoader } = loaderSlice.actions;

export default loaderSlice.reducer;